import { useMemo } from 'react'
import { CoverLetter, Resume } from '@rio/types'
import { Colors } from 'builder/components/DocumentCustomizationModal/Colors'
import { useI18n } from 'builder/hooks/useI18n'
import { DocumentTypes } from 'builder/modules/constants'
import { ColorChangeHandler } from 'builder/modules/resumeEditor'
import { useTemplateCustomization } from '../../hooks/useTemplateCustomization'
import { ColorsContainer, ColorsLabel } from './styles'

interface ColorSelectionProps {
  isScrolled?: boolean
  handleColorPickerOpen?: () => void
  handleColorSelect: ColorChangeHandler
  currentDocument: Resume | CoverLetter
}

export const ColorSelection = (props: ColorSelectionProps) => {
  const {
    isScrolled = true,
    handleColorPickerOpen = () => {},
    handleColorSelect,
    currentDocument,
  } = props
  const { i18n } = useI18n()
  const { currentTemplate, resumeSpecificTemplateSettings, supportsNewCustomization } =
    useTemplateCustomization(currentDocument)

  const colorSettings = useMemo(() => {
    const templateSettings = currentTemplate?.settings
    const templateColor = templateSettings?.color
    const supportsCustomColor = currentTemplate?.supportsCustomColor

    const getSelectedColor = () => {
      if (currentDocument) {
        if (currentDocument.type === DocumentTypes.resume && supportsNewCustomization) {
          return resumeSpecificTemplateSettings?.color || templateColor?.default
        }
        return currentDocument.color || templateColor?.default
      }
      return templateColor?.default || null
    }

    const selected = getSelectedColor()
    const options = templateColor?.values || []

    return { selected, options, supportsCustomColor }
  }, [
    currentTemplate?.settings,
    currentTemplate?.supportsCustomColor,
    currentDocument,
    supportsNewCustomization,
    resumeSpecificTemplateSettings?.color,
  ])

  return (
    <ColorsContainer isScrolled={isScrolled}>
      <ColorsLabel isScrolled={isScrolled}>
        {i18n.t('builder.resume_editor.document_customization.sidebar.templates_tab.colors')}
      </ColorsLabel>
      <Colors
        onSelect={handleColorSelect}
        {...colorSettings}
        handleColorPickerOpen={handleColorPickerOpen}
      />
    </ColorsContainer>
  )
}
